import axios from "axios";
import apiConfig from "../../config/api-config";
import config from "../../config/local-config";
import createFormData from "./createFormData";

const version = "v1.0";
const serviceName = "resendVerifyEmail";
const apiUrl = `${apiConfig.apiURL}/MyAccount/${version}/${serviceName}`;

const resendVerificationEmail = (email = "") => {
  // Creating payload to add selected product
  let body = {
    domain: config.hydra.site,
    email: email
  };

  // added data into fordata for post request
  const bodyFormData = createFormData(body);
  // returning promise for the request
  return axios.post(apiUrl, bodyFormData, {
    headers: {
      apikey: apiConfig.apiKey
    }
  });
};

export default resendVerificationEmail;
